export default __webpack_public_path__ + "static/media/sales_analytics_orange.e3b2df0f.svg";